import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';

import AppBar from './components/AppBar/AppBar';
import Footer from './components/Footer/Footer';

import SearchPage from './pages/SearchPage';
import AboutPage from './pages/AboutPage';
import NotFound from './pages/NotFound';

function App() {
  return (
    <BrowserRouter>
      <RecoilRoot>
        <div className="Site">
          <AppBar />
          <div className="Site-content">
            <Routes>
              <Route path={process.env.PUBLIC_URL} element={<SearchPage />} />
              <Route
                path={`${process.env.PUBLIC_URL}/about`}
                element={<AboutPage />}
              />
              <Route path="*" element={<NotFound></NotFound>}></Route>
            </Routes>
          </div>
          <Footer />
        </div>
      </RecoilRoot>
    </BrowserRouter>
  );
}

export default App;
